import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { SideChannelMenuComponent } from 'src/app/common/components/side-channel-menu/side-channel-menu.component';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { LoginService } from 'src/app/managers/login.service';
import { Category } from 'src/app/models/category';
import { Channel } from 'src/app/models/channel';
import { Subscription } from 'rxjs';
import { RssFeedService } from 'src/app/managers/rssFeed.service';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';

@Component({
  selector: 'app-edit-channel',
  templateUrl: './edit-channel.component.html',
  styleUrls: ['./edit-channel.component.css']
})
export class EditChannelComponent extends BaseComponent implements OnInit, OnDestroy {
  updatedChannels: Channel[];
  channel: Channel;
  channels: Channel[];
  category: Category;
  categories: Category[];
  categoryControl = new FormControl('', Validators.required);
  channelControl = new FormControl('', Validators.required);
  categoryControlSubscription: Subscription;
  channelControlSubscription: Subscription;
  selectedId: number;
  selectedCategoryId: number;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _functionsService: FunctionsService,
              private _snackBar: MatSnackBar, public dialogRef: MatDialogRef<SideChannelMenuComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private _rssFeedService: RssFeedService) { 
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.dataSource = this._functionsService.deepCopy<Category[]>(this.data.dataSource);
    this.channels = [];
    this.updatedChannels = [];

    this.composeChannels();
    this.categories = this._functionsService.deepCopy<Category[]>(this.data.dataSource);

    if (this.data.action === 'Add') {
      this.channel = new Channel();
      this.selectedCategoryId = this.categories[0].Id;
      this.category = this._functionsService.deepCopy<Category>(this.categories[0]);
    }
    else {
      if (this.channels.length > 0) {
        this.selectedId = this.channels[0].Id;
        this.channel = this._functionsService.deepCopy<Channel>(this.channels[0]);
      }
      else {
        this.selectedId = 0;
        this.channel = new Channel();
      }
    }

    this.channelControlSubscription = this.channelControl.valueChanges.subscribe(value => {
      if (this.data.action === 'Edit' || this.data.action === 'Remove') {
        if (this.channels.length > 0) {
          this.channel = this._functionsService.deepCopy<Channel>(this.channels.filter(c => c.Id === this.channelControl.value)[0]);
        }
      }
    });

    this.categoryControlSubscription = this.categoryControl.valueChanges.subscribe(value => {
      if (this.data.action === 'Add') {
        this.category = this._functionsService.deepCopy<Category>(this.categories.filter(c => c.Id === this.categoryControl.value)[0]);
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.channelControlSubscription.unsubscribe();
    this.categoryControlSubscription.unsubscribe();
  }

  enableActionButton(): boolean {
    if (this.data.action === 'Add') {
      if (!this._functionsService.isNullOrUndefined(this.channel) && this.channel.Title !== undefined && this.channel.ChannelUrl !== undefined) 
        return (this.selectedCategoryId > 0 && this.channel.Title.length > 0 && this.channel.ChannelUrl.length > 0) ? true : false;
      else
        return false;
    }
    else if (this.data.action === 'Edit') {
      if (!this._functionsService.isNullOrUndefined(this.channel) && this.channel.Title !== undefined && this.channel.ChannelUrl !== undefined) 
        return (this.selectedId > 0 && this.channel.Title.length > 0 && this.channel.ChannelUrl.length > 0) ? true : false;
      else
        return false;
    }
    else if (this.data.action === 'Remove') {
      return this.selectedId > 0 ? true : false;
    }
  }

  actionClick() {
    if (this.data.action === 'Add') {
      if (this.isDupeChannel(true)) {
        let alertStr = "Can't add because either the same subscription URL or Title already exists";
        this.openAlertDialog('Add Subscription', alertStr, '500px', '200px');
      }
      else
        this.addChannel();
    }
    else if (this.data.action === 'Edit') {
      if (this.isDupeChannel(false)) {
        let alertStr = "Can't update because the same subscription URL/Title already exists";
        this.openAlertDialog('Edit Subscription', alertStr, '500px', '200px');
      }
      else
        this.editChannel();
    }
    else if (this.data.action === 'Remove') {
      this.removeChannel();
    }
  }

  closeClick() {
    this.dialogRef.close(this.updatedChannels);
  }

  //The function populates this.channels array
  private composeChannels() {
    this.dataSource.map(category => {
      category.Channels.map(channel => {
        let glChannels = this.channels.filter(c => c.Id === channel.Id);

        if (glChannels.length > 0) {
          //channel was already added and exists so add its category to channel.Categories array
          let glChannel: Channel = glChannels[0];
          glChannel.Categories.push(this._functionsService.deepCopy<Category>(category));
        }
        else {
          //channel is not available because not added yet
          let glChannel = this._functionsService.deepCopy<Channel>(channel);
          glChannel.Categories = [];
          glChannel.Categories.push(this._functionsService.deepCopy<Category>(category));
          this.channels.push(glChannel); 
        }
      });
    });

    this.channels.sort((a, b) => a.Title > b.Title ? 1 : -1);
  }

  private isDupeChannel(addAction: boolean): boolean {
    let results = this.channels.filter(c => c.ChannelUrl.toLowerCase() === this.channel.ChannelUrl.toLowerCase() 
                                       || c.Title.toLowerCase() === this.channel.Title.toLowerCase())
    if (addAction) {
      return results.length > 0 ? true : false;
    }
    else {
      return results.filter(c => c.Id !== this.channel.Id).length > 0 ? true : false;
    }
  }

  private async removeChannel() {
    let responseMsg: CoreResponseMessage;

    this._snackBar.open('Removing...');
    responseMsg = await this._rssFeedService.removeChannelAsync(this.getLoggedinUser(), this.channel);
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open('The subscription ' + this.channel.Title + ' has been removed', 'OK', { duration: this._successMsgDuration });
      this.updatedChannels.push(this._functionsService.deepCopy<Channel>(this.channel));
      this.channels = this.channels.filter(c => c.Id !== this.channel.Id);

      if (this.channels.length > 0) {
        this.selectedId = this.channels[0].Id;
        this.channel = this.channels[0];
      }
      else {
        this.selectedId = 0;
        this.channel = new Channel();
      }
    }
    else {
      this._snackBar.open('Failed to remove the subscription: ' + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
      this.handleCoreResponseMessageError(responseMsg);
    }
  }

  private async editChannel() {
    let responseMsg: CoreResponseMessage;

    this._snackBar.open('Editing...');
    responseMsg = await this._rssFeedService.updateChannelAsync(this.getLoggedinUser(), this.channel);
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open('The subscription has been updated', 'OK', { duration: this._successMsgDuration });
      this.updatedChannels.push(this._functionsService.deepCopy<Channel>(this.channel));

      for (let index = 0; index < this.channels.length; index++) {
        if (this.channels[index].Id === this.channel.Id) {
          this.channels[index].Title = this.channel.Title;
          this.channels[index].ChannelUrl = this.channel.ChannelUrl;
        }
      }

      this.channels.sort((a, b) => a.Title > b.Title ? 1 : -1);
    }
    else {
      this._snackBar.open('Failed to edit: ' + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
      this.handleCoreResponseMessageError(responseMsg);
    }
  }

  private async addChannel() {
    let responseMsg: CoreResponseMessage;  

    this._snackBar.open('Adding subscription. Please wait...');
    this.channel.Categories = [this._functionsService.deepCopy<Category>(this.category)];
    responseMsg = await this._rssFeedService.addChannelAsync(this.getLoggedinUser(), this.channel);
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open('The subscription has been added', 'OK', { duration: this._successMsgDuration });

      let insertedChannel = responseMsg.Result[0];
      this.channel.Id = insertedChannel.Id;
      this.channel.ImageUrl = insertedChannel.ImageUrl;

      this.updatedChannels.push(this._functionsService.deepCopy<Channel>(this.channel));
      this.channels.push(this._functionsService.deepCopy<Channel>(this.channel));
      this.channel = new Channel();

      this.channels.sort((a, b) => a.Title > b.Title ? 1 : -1);
    }
    else {
      this.openAlertDialog('Add Channel', 'Failed to add: ' + responseMsg.Message, '400px', '200px');
    }
  }
}
